<template>
    <div class="app">
       <div class="header_top">
         <div class="left">
           <div class="left_ren"></div>
           <div class="left_txt">您好，欢迎访问中国循环杂志</div>
         </div>
         <div class="right">
<!--           <div class="Sign">
             <div class="sign_txt">登录</div>
             <div class="shu"></div>
             <div class="sign_txt">注册</div>
           </div> -->
           <div class="right_txt">{{time}}</div>
         </div>
       </div>
       <div class="header_bottom">
          <div class="header_bottom_nav">
            <div style="overflow: hidden;padding-bottom: 20px;width: 86.5%;float: left;padding-top: 25px;">
              <img src="../../assets/logo.jpg" class="logo"/>
                 <div class="search">
                   <div class="search_top">
                     <div class="sou">
                       <div class="input">
<!--                         <div class="right1">
                          <div class="iconfont righta iconxiajiantou"></div>
                           <div class="right">
                             <div class="rightb">主题</div>
                           </div>
                         </div>
                         <div class="hui"></div> -->
                         <input placeholder="请输入关键词搜索" class="inputhui" v-model="searchtxt"  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" style="padding-left: 15px;"/>
                         <div class="btn" style="position: absolute;right: 0;" @click="jumpsou">
                           <div class="txt">搜索</div>
                         </div>
                       </div>
                     </div>
                     <!-- <div class="sou_txt">
                       <div class="sou_txt1">ISSN 1673-7245</div>
                       <div class="sou_txt1">CN 11-5540/R</div>
                     </div> -->
                   </div>
                   <!-- <div class="search_bottom">
                     <div class="search_txt">主 办：中华预防医学会、福建医科大学</div>
                     <div class="search_txt" style="margin-right: 60px;">主 管：国家卫生健康委员会</div>
                   </div> -->
                 </div>
            </div>

          </div>
       </div>
       <div class="Navigation" :class="istabBar?'isFixed':''">
         <ul>
           <li v-for="(item,index) in list" :key="index" :class="xzid==item.id?'add':''" @click="jump(item.id)">
            {{item.txt}}
<!--            <div class="dingwei" v-if="item.zt">
              <div class="dingwei2">
                <div class="dingwei3" v-for="(item,index) in zi"><span>></span>{{item.txt}}</div>
              </div>
            </div> -->
           </li>
         </ul>
       </div>
    </div>
</template>

<script>

import axios from 'axios'

 export default {
  data () {
    return {
        time: '',
        xzid: 0,//被选中的添加样式的导航id
        istabBar: false,
        searchtxt: '',//搜索关键词
        list: [
          {
            id: 0,
            txt: '首页',
          },
          {
            id: 5,
            txt: '期刊简介'
          },
          {
            id: 2,
            txt: '编委会'
          },
          {
            id: 4,
            txt: '期刊目录'
          },
          {
            id: 14,
            txt: '阜外在线'
          },
          {
            id: 8,
            txt: '阜外说心脏'
          },
          {
            id: 3,
            txt: '作者中心'
          },
          {
            id: 7,
            txt: '优先出版'
          },
          // {
          //   id: 9,
          //   txt: '学术人生'
          // },
          // {
          //   id: 10,
          //   txt: '学术指导'
          // },
          {
            id: 11,
            txt: '出版政策'
          },
          // {
          //   id: 1,
          //   txt: '名刊速览'
          // },
          {
            id: 6,
            txt: '项目合作'
          },
          // {
          //   id: 10,
          //   txt: '精华转载'
          // },
          {
            id: 12,
            txt: '联系我们'
          },
           {
            id: 13,
            txt: 'English'
          }
        ],//导航栏
        zi: [],//子级
    }
  },
  methods:{
        //获取网站首页 导航栏目
        GetParentSiteChannel() {
          var that = this;
          that.$httphelper.GetParentSiteChannel({
            "journalId": 201607080003
          }).then(res => {
            alert('123')
            if(res.code==200){
              that.list = res.data || '';
              that.$loading.hideLoading();
            }else{
              that.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
              });
            }
          });
        },
        //获取网站首页 子级导航栏目
        GetChildSiteChannel(id) {
          var that = this;
          that.$httphelper.GetChildSiteChannel({
            "journalId": 201607080003,
            'parentId': id
          }).then(res => {
            if(res.code==200){
              that.zi = res.data || '';
              if(that.zi.length>0){
                for(var i=0;i<that.list.length;i++){
                  if(id==that.list[i].channelId){
                    that.list[i].zt = true;
                    that.list.push('1');
                    that.list.pop('1');
                  }else{
                    that.list[i].zt = false;
                    that.list.push('1');
                    that.list.pop('1');
                  }
                }
              }
            }else{
              that.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
              });
            }
          });
        },
        //鼠标悬停显示二级菜单
        addtop(num,id){
          if(num==1){
            this.GetChildSiteChannel(id);
          }else{
            for(var i=0;i<this.list.length;i++){
              this.list[i].zt = false;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        },
        addtop2(){
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        },
        //点击切换导航页
        jump(id){
          console.log(id,'id!!!')
          if(id!=11){
            this.xzid = id;
          }
          sessionStorage.setItem('routerIndex',this.xzid);
          if(id==0){
            //首页
            this.$router.push({path:'/home'});
          }else if(id==1){
            //杂志沿革
            this.$router.push({path:'/evolution'});
          }else if(id==2){
            //编委风采
            this.$router.push({path:'/editorial'});
          }else if(id==3){
            //历届会议
            this.$router.push({path:'/oldmeeting'});
          }else if(id==4){
            //过刊浏览
            this.$router.push({path:'/browse'});
          }else if(id==5){
            //指南与共识
            this.$router.push({path:'/guide'});
          }else if(id==6){
            // this.$router.push({path:'/evolution',query: {name:'编辑掠影',}});
            //编辑掠影
            this.$router.push({path:'/evolution2'});
          }else if(id==7){
            //专家箴言
            this.$router.push({path:'/expert'});
          }else if(id==8){
            //外科天地
            window.open('https://www.fuwaionline.org.cn/m/index/special-detail/1075?sid=188')
            // this.$router.push({path:'/surgery'});
          }else if(id==9){
            //学术人生
            this.$router.push({path:'/consulting'});

          }else if(id==10){
            //精华转载
            this.$router.push({path:'/reprint'});
          }else if(id==11){
            //高血压论坛
            this.$router.push({path:'/evolution3',query:{
               id:4089,title:'出版政策'
              }});
          }else if(id==12){
            //高血压论坛
            this.$router.push({path:'/contact'});
          }else if(id==13){
            //英文网站
            window.open('https://chinacirculation.org/en/#/home');
          }else if(id==14){
            window.open('https://www.fuwaionline.org.cn/m/index/index/1075');
          }
        },
        //滚动固定导航栏
        handleScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 200){
                this.istabBar = true
            } else {
                this.istabBar = false
            }
        },
        jumpsou(){
          if(this.searchtxt==''){
            this.$alert('搜索内容不能为空', '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }else{
            this.$router.push({path:'/search',query:{searchtxt: this.searchtxt}});
            this.searchtxt = '';
          }
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll); // Dom树加载完毕
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll) // 销毁页面时清除
    },
    created(){
      // this.$loading.showLoading();
      // this.GetParentSiteChannel();
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()+1;
      var day = date.getDate();
      var xingqi = date.getDay();
      switch(xingqi){
        case 0:
         xingqi = "日";
         break;
        case 1:
         xingqi = "一";
         break;
        case 2:
         xingqi = "二";
         break;
        case 3:
         xingqi = "三";
         break;
        case 4:
         xingqi = "四";
         break;
        case 5:
         xingqi = "五";
         break;
        case 6:
         xingqi = "六";
         break;
      }
      this.time = year+"年"+month+"月"+day+"日"+" 星期"+xingqi
      var xzid = sessionStorage.getItem('routerIndex');
      if(xzid){
         this.xzid = Number(xzid);
      }else{
        this.xzid = 0;
      }
      if(this.$route.query.searchtxt){
        this.searchtxt = this.$route.query.searchtxt;
      }
    },
    watch:{
      $route(to,from){
        var xzid = sessionStorage.getItem('routerIndex');
        if(xzid){
           this.xzid = Number(xzid);
        }else{
          this.xzid = 0;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
img{
    border: none;
}
.app{
    width: 100%;
    min-width: 1366px;
    line-height: 40px;
    background: #F1F1F1;
    .header_top{
      width: 85%;
      margin: 0 auto;
      overflow: hidden;
      .left{
        width: 30%;
        float: left;
        overflow: hidden;
        .left_ren{
          width: 15px;
          height: 17px;
          display: inline-block;
          margin-right: 16px;
        }
        .left_txt{
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          display: inline-block;
        }
      }
      .right{
        width: 50%;
        float: right;
        overflow: hidden;
        .right_txt{
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #000000;
          line-height: 38px;
          margin-right: 55px;
          float: right;
        }
        .Sign{
          width: 90px;
          float: right;
          overflow: hidden;
          .sign_txt{
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            float: left;
          }
          .shu{
            width: 1px;
            height: 17px;
            background: #9E9E9E;
            margin: 0 10px;
            margin-top: 10px;
            float: left;
          }
        }
      }
    }
    .header_bottom{
        width: 100%;
        overflow: hidden;
        background-color: #F7F8FA;
        .header_bottom_nav{
          width: 85%;
          margin: 0 auto;
          overflow: hidden;
          .logo{
            width: 42%;
            //height: 150px;
            float: left;
            // object-fit: cover;
          }
          .search{
            width: 51%;
            float: left;
            overflow: hidden;
            margin-left: 7%;
            .search_top{
              width: 100%;
              overflow: hidden;
              .sou {
                width: 55%;
                height: 36px;
                background: #FFFFFF;
                border: 1px solid red;
                border-radius: 20px;
                float: left;
                position: relative;
                margin-top: 58px;
                .input {
                  width: 100%;
                  height: 36px;
                  .right1 {
                    overflow: hidden;
                    width: auto;
                    max-width: 32%;
                    margin-left: 3%;
                    float: left;
                    line-height: 29px;
                    .right {
                      float: right;

                      .rightb {
                        font-size: 14px;
                        font-family: Source Han Sans SC;
                        font-weight: 400;
                        color: #595959;
                        line-height: 36px;
                      }
                    }

                    .righta {
                      float: right;
                      font-size: 14px;
                      margin-left: 11px;
                      color: #EB5C30;
                      line-height: 36px;
                    }
                  }

                  .hui {
                    width: 2px;
                    height: 12px;
                    background: #CACACA;
                    float: left;
                    margin: 14px 9px 0 15px;
                  }

                  .inputhui {
                    width: 70%;
                    height: 36px;
                    line-height: 36px;
                    margin: 0;
                    float: left;
                    font-size: 14px;
                    border: 0;  // 去除未选中状态边框
                    outline: none; // 去除选中状态边框
                    background-color: rgba(0, 0, 0, 0);// 透明背景
                    color: var(--xt);
                    // color: red;;
                  }

                  .btn {
                    cursor: pointer;
                    float: right;
                    width: 20%;
                    height: 36px;
                    background: red;
                    border: 1px solid red;
                    text-align: center;
                    font-size: 14px;
                    border-radius: 18px;
                    .txt {
                      font-size: 14upx;
                      font-family: Adobe Heiti Std;
                      font-weight: normal;
                      color: #F7F8FA;
                      line-height: 13px;
                      margin-top: 10px;
                    }
                  }
                }
              }
              .sou_txt{
                width: 120px;
                float: right;
                margin-right: 20px;
                margin-top: 40px;
                .sou_txt1{
                  width: 100%;
                  font-size: 14px;
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  color: #949494;
                  line-height: 28px;
                }
              }
            }
            .search_bottom{
              width: 100%;
              float: right;
              overflow: hidden;
              margin-top: 13px;
              .search_txt{
                font-size: 14px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #949494;
                float: right;
                text-align: right;
              }
            }
          }
          .book{
            width: 13.5%;
            height: 185px;
            float: left;
            margin-top: 10px;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
    }
    .Navigation{
      width: 100%;
      min-width: 1366px;
      height: 70px;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
      background: #E60112;
      z-index: 1000;
      ul{
        display: flex;
        justify-content: space-between;
        list-style: none;
        width: 85%;
        margin: 0 auto;
        // height: 50px;
        // line-height: 70px;
        li{
          line-height: 70px;
          margin-bottom: -20px;
          font-size: 18px;
          font-family: Source Han Sans SC;
          color: #FFFFFF;
          float: left;
          cursor: pointer;
          text-align: center;
          position: relative;
          .dingwei{
            width: 100%;
            position: absolute;
            left: 0;
            background-color: #FFFFFF;
            box-shadow: 0px 1px 15px 0px rgba(150, 150, 150, 0.2);
            z-index: 10;
            .dingwei2{
              width: 95%;
              margin: 0 auto;
              padding: 20px 0;
              .dingwei3{
                font-size: 16px;
                font-family: Source Han Sans SC;
                font-weight: 400;
                color: #000000;
                line-height: 23px;
              }
              .dingwei3:hover{
                color: var(--xt);
              }
            }
          }
        }
      }
    }
}
.add{
  // background-color: #D13808;
  text-decoration: underline;
  font-weight: bold;
  // padding-top:2px ;
  // border-bottom: 1px solid #ccc;
  // padding-bottom: 10px;
}
.isFixed {
  position: fixed;
  top: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue